/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ListFilterOptionsPayload,
  ListFilterOptionsPayload$Outbound,
  ListFilterOptionsPayload$outboundSchema,
} from "../components/listfilteroptionspayload.js";

export type ListFilterOptionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListFilterOptionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListFilterOptionsSecurity = {
  option1?: ListFilterOptionsSecurityOption1 | undefined;
  option2?: ListFilterOptionsSecurityOption2 | undefined;
};

export type ListFilterOptionsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  listFilterOptionsPayload: ListFilterOptionsPayload;
};

/** @internal */
export type ListFilterOptionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListFilterOptionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListFilterOptionsSecurityOption1$Outbound,
  ListFilterOptionsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listFilterOptionsSecurityOption1ToJSON(
  listFilterOptionsSecurityOption1: ListFilterOptionsSecurityOption1,
): string {
  return JSON.stringify(
    ListFilterOptionsSecurityOption1$outboundSchema.parse(
      listFilterOptionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListFilterOptionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListFilterOptionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListFilterOptionsSecurityOption2$Outbound,
  ListFilterOptionsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listFilterOptionsSecurityOption2ToJSON(
  listFilterOptionsSecurityOption2: ListFilterOptionsSecurityOption2,
): string {
  return JSON.stringify(
    ListFilterOptionsSecurityOption2$outboundSchema.parse(
      listFilterOptionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListFilterOptionsSecurity$Outbound = {
  Option1?: ListFilterOptionsSecurityOption1$Outbound | undefined;
  Option2?: ListFilterOptionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListFilterOptionsSecurity$outboundSchema: z.ZodMiniType<
  ListFilterOptionsSecurity$Outbound,
  ListFilterOptionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListFilterOptionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListFilterOptionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listFilterOptionsSecurityToJSON(
  listFilterOptionsSecurity: ListFilterOptionsSecurity,
): string {
  return JSON.stringify(
    ListFilterOptionsSecurity$outboundSchema.parse(listFilterOptionsSecurity),
  );
}

/** @internal */
export type ListFilterOptionsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ListFilterOptionsPayload: ListFilterOptionsPayload$Outbound;
};

/** @internal */
export const ListFilterOptionsRequest$outboundSchema: z.ZodMiniType<
  ListFilterOptionsRequest$Outbound,
  ListFilterOptionsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    listFilterOptionsPayload: ListFilterOptionsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      listFilterOptionsPayload: "ListFilterOptionsPayload",
    });
  }),
);

export function listFilterOptionsRequestToJSON(
  listFilterOptionsRequest: ListFilterOptionsRequest,
): string {
  return JSON.stringify(
    ListFilterOptionsRequest$outboundSchema.parse(listFilterOptionsRequest),
  );
}
